// opervex-frontend/src/contexts/AuthContext.js

import { createContext, useContext, useEffect, useState } from "react";
import Opervex from "../Opervex";
import axios from "axios";
import OpervexStorage from "../utils/OpervexStorage";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loadingGlobal, setGlobalLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState(null);
  const [tenantId, setTenantId] = useState(null);

  const checkAuth = async () => {
    try {
      // 🔁 valida troca de tenant (se já existir essa regra)
      OpervexStorage.checkTenantChange();

      const storedUser = OpervexStorage.getUser();
      const storedRoles = OpervexStorage.getRoles();
      const storedTenantId = OpervexStorage.getTenantId();
      const expired = OpervexStorage.isExpired();

      if (storedUser && storedTenantId && !expired) {
        setUser(storedUser);
        setRoles(storedRoles);
        setTenantId(storedTenantId);
      } else {
        OpervexStorage.clear();
        setUser(null);
        setRoles(null);
        setTenantId(null);
      }
    } catch (err) {
      console.error("Erro ao verificar autenticação:", err);
    } finally {
      setInitialized(true);
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  /**
   * ============================
   * LOGIN
   * ============================
   */
  const login = async (tenantId, username, password) => {
    try {
      setGlobalLoading(true);

      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/${tenantId}/Auth`, { username, password });

      if (data?.message !== "success") {
        setGlobalLoading(false);
        return null;
      }

      const userData = {
        id: data.id,
        username: data.username,
        administrator: data.administrator,
        fullname: data.fullname,
        email: data.email,
        initialPassword: data.initialPassword,
        avatar: data.image,
        token: data.token,
      };

      // 🔥 SALVA PRIMEIRO
      OpervexStorage.setAll({
        tenantId,
        user: userData,
        roles: [],
        expiration: data.expiresIn,
      });

      const rolesData = await new Opervex(tenantId).System.UserProfile.findUserId(data.id);

      // Atualiza roles no storage
      OpervexStorage.setAll({
        tenantId,
        user: userData,
        roles: rolesData,
        expiration: data.expiresIn,
      });

      // 🧠 estado global
      setTenantId(tenantId);
      setUser(userData);
      setRoles(rolesData);

      setGlobalLoading(false);
      return userData;
    } catch (error) {
      console.error("Erro no login:", error);
      setGlobalLoading(false);
      return null;
    }
  };
  const updatePassword = async (password) => {
    try {
      const data = await new Opervex(OpervexStorage.getTenantIdFromPath()).System.User.updatePassword(user.id, { password });
      return data;
    } catch (error) {
      console.error("Erro no updatePassword:", error);
      return null;
    }
  };

  /**
   * ============================
   * LOGOUT
   * ============================
   */
  const logout = () => {
    OpervexStorage.clear();
    setUser(null);
    setRoles(null);
    setTenantId(null);
  };

  if (!initialized) return null;

  return (
    <AuthContext.Provider
      value={{
        user,
        roles,
        tenantId,
        isAuthenticated: !!user,
        loadingGlobal,
        login,
        logout,
        updatePassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
